module.exports = __webpack_public_path__ + "img/Bpoint4.e2799693.png";